<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
   data(){
   	  return{

   	  }
   },
   created(){

   },
   methods:{

   }
}
</script>

<style>
    .jf_container .assort .el-input__inner {
        width: 176px;
    }
    .jf_conditionBox.kaohe .my-search {
        width: 180px;
    }
    .jf_conditionBox.kaohe .picker {
        width: 300px!important;
    }
    .jf_conditionBox.kaohe .el-input__inner {
        width: 150px;
    }
    .jf_container .el-table th {
        background: #f1f1f1;
        /* background:linear-gradient(to bottom, #f1f1f1 90%, #fff); */
    }
    .jf_container .el-table th:first-child {
        border-radius: 10px 0 0 0;
    }
    .jf_container .el-table th:nth-last-child(1) {
        border-radius: 0 10px 0 0;
    }
    .jf_container .el-range-separator {
        width: 8%;
    }
    .elDialog .el-dialog {
        border-radius: 10px;
        width: 350px !important;
        text-align: center;
    }
    .elDialog .el-dialog__body {
        padding: 40px 20px 10px;
    }
    .elDialog .tip::before {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        border-radius: 50%;
        border: 1px solid #E6BE8A;
        width: 20px;
        height: 20px;
        content: "!";
        text-align: center;
        font-weight: 600;
        color: #E6BE8A;
    }
    .elDialog .el-dialog__footer {
        text-align: center;
    }
    .elDialog .el-dialog .el-button {
        margin: 0 26px 0;
        width: 80px;
        border-color: #E6BE8A;
        color: #E6BE8A;
    }
    .elDialog .el-dialog .el-button--primary {
        color: #fff;
        background: #E6BE8A;
    }
    .rejectDialog .el-dialog__body {
        text-align: left;
    }
    .jf_container .el-pager .active {
        background: #E6BE8A;
    }
    .jf_container .myDialog {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        z-index: 999;
    }
    .jf_container .myDialog li {
        list-style: none;
    }
    .jf_container .myDialog_content {
        position: relative;
        overflow: hidden;
        border-radius: 10px;
        width: 706px;
        min-height: 100px;
        padding-bottom: 40px;
        background: #fff;
    }
    .jf_container .myDialog_h {
        height: 37px;
        padding-left: 24px;
        line-height: 37px;
        color: #E6BE8A;
        background: #f1f1f1;
    }
    .jf_container .myDialog_content .createBtn {
        margin: 10px 30px 0 0;
        height: 30px !important;
    }
    .assortList  {
        margin: 0 auto 15px;
        border-radius: 4px;
        width: 660px;
        /* height: 30px; */
        background: #f1f1f1;
    }
    .first_item {
        margin-top: 50px;
    }
    .assortList  span {
        float: right;
        margin: 0 30px;
        font-size: 16px;
        color: #797979;
        line-height: 30px;
        cursor: pointer;
    }
    .assortList  .assort_name {
        float: left;
        margin: 0 0 0 20px;
        width: 290px;
    }
    .assort_name i {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #E6BE8A;
        vertical-align: middle;
        cursor: pointer;
        transition: transform 0.3s;
    }
    .assort_child {
        overflow: hidden;
        margin-top: 30px;
        box-shadow: 0 10px 10px 0 rgba(124, 114, 193, 0.2);
        border-radius: 0 0 10px 10px;
        width: 100%;
        height: 0;
        background: #fff;
        transition: height 0.3s;
    }
    .activeI {
        transform: rotate(90deg)
    }
    .assort_confim-btn {
        display: block;
        margin: 20px auto 0;
        border-radius: 4px;
        border: 1px solid #E6BE8A;
        outline: none;
        width: 80px;
        height: 30px;
        font-size: 16px;
        color: #E6BE8A;
        background: none;
    }
    .assort_add .el-input, .rule_add .el-input {
        width: 250px;
    }
    .rule_add .el-textarea {
        width: 556px;
    }
    .kaoheAdd .el-textarea {
        width: 415px;
    }
    .inp_wrap {
        margin: 20px 0 0 30px;
    }
    .inp_wrap label {
        width: 80px;
    }
    .inp_wrap .count {
        display:inline-flex!important;
        align-items: center!important;
        border-radius: 4px!important;
        border: 1px solid #dcdfe6!important;
        width: 150px!important;
        padding-top: 0!important;
    }
    .inp_wrap .count .el-input-number {
        width: 70px!important;
    }
    .inp_wrap .count .el-input-number span {
        border: none!important;
        width: 20px!important;
    }
    .inp_wrap .count .el-input {
        width: 50px!important;
    }
    .inp_wrap .count .el-input__inner {
        border: none!important;
        padding: 0!important;
    }
    .jf_container .count .leftCount span {
        left: 0!important;
    }
    .leftCount .el-input {
        margin-left: 20px!important;
    }
    .inp_wrap label.el-radio {
        width: 70px;
    }
    .jf_container .el-radio+.el-radio {
        margin-left: 0px;
    }
    .jf_container .el-radio__label {
        padding-left: 4px;
    }
    .countInp.el-input {
        width: 60px;
    }
    .countInp.el-input .el-input__inner {
        padding: 0;
        text-align: center;
    }
    .jf_container .multiple_selection .el-input {
        width: 470px;
    }
    .jf_container .multiple_selection .el-tag {
        color: #E6BE8A;
        background: #f1f1f1;
    }
    .jf_container .myTip .el-message-box__btns {
        text-align: center
    }
    .jf_container .myTip .el-button {
        margin: 0 20px;
        border-radius: 4px;
        border: 1px solid #E6BE8A;
        outline: none;
        width: 70px;
        font-size: 14px;
        color: #E6BE8A;
        background: none;
    }
    .jf_container .myTip .el-button--primary {
        color: #fff;
        background: #E6BE8A;
    }
    .jf_container .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #E6BE8A;
    }
    .pageTotal {
        margin: 20px 0 0 30px;
    }
    .pageBody {
        margin-top: 20px;
        text-align: center;
    }
    .shenqing-myDialog_content .el-input, .shenqing-myDialog_content .el-select {
        width: 150px!important;
    }

    .shuju .el-input {
        width: 120px;
    }
    .shuju .el-range-input {
        width: 100px;
    }
    .shuju .picker {
        width: 280px;
    }
    .shuju .my-search {
        display: inline-block;
        width: 160px!important;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .jf_conditionBox.jifenjilu .el-input {
        width: 150px;
    }
    .duihuan_dialog .el-input--suffix {
        width: 400px;
    }
    .duihuan_dialog .el-select__tags {
        width: 400px;
    }
    .duihuanTable.el-table th {
        background: #f1f1f1;
    }
    .jf_container .gutter {
        background: none!important;
    }
    .mynewlist .el-dialog.el-dialog--center {
        margin-top: 5vh!important;
    }
    .el-tooltip__popper.is-dark {
        max-width: 500px!important;
    }
    .jf_container *::-webkit-scrollbar {
        display: none;
    }
    .jf_container .el-icon-circle-close {
        font-size: 24px!important;
    }
</style>
<style>
  .el-dialog__header {
    padding: 8px 20px;
    color: #FFFFFF;
    background: #E6BE8A;
    text-align: center;
  }

  .el-dialog__title {
    color: #FFFFFF;
  }

  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .el-dialog__headerbtn {
    top: 13px;
  }

  .el-date-editor .el-range-separator{
    width: auto;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue